import React from "react";

import "./header.scss";
const Header = () => {
  return (
    <div className="header">
      <div className="logo">
        <span>React Blog</span>
      </div>
    </div>
  );
};

export default Header;
